class CartDeliveryFeeController {
    constructor($sce, settings, shopperService, trolleyService, deliveryPassService, deliveryFeeService, deliverySaverConstants) {
        this.$sce = $sce;
        this.settings = settings;
        this.shopperService = shopperService;
        this.trolleyService = trolleyService;
        this.deliveryPassService = deliveryPassService;
        this.deliveryFeeService = deliveryFeeService;
        this.deliverySaverConstants = deliverySaverConstants;

        this.deliveryFeeStructure = null;
    }

    $onInit() {
        this.showDeliveryFeeStructure = false;

        this.deliveryPassService.showShopperDeliveryPassPrompt();
    }

    toggleDeliveryFeeStructure() {
        this.showDeliveryFeeStructure = !this.showDeliveryFeeStructure;

        if (this.showDeliveryFeeStructure) {
            this.deliveryFeeService.getDeliveryFeeStructure().then((response) => {
                this.deliveryFeeStructure = response;
            });
        }
    }

    showDeliveryPassPrompt() {
        return !this.showDeliveryFeeStructure
        && !this.settings.deliverySaver.isEnabled
        && (this.deliveryPassService.deliveryPassPrompt.ContentText || this.deliveryPassService.deliveryPassPrompt.PromptText);
    }

    showDeliveryPlusSuspended() {
        return this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.SUSPENDED;
    }
}

CartDeliveryFeeController.$inject = ['$sce', 'Settings', 'ShopperService', 'TrolleyService', 'DeliveryPassService', 'DeliveryFeeService', 'DeliverySaverConstants'];

const cartDeliveryFeeComponentDefinition = {
    controller: CartDeliveryFeeController,
    template: require('./cart-delivery-fee.component.html').trim(),
};

module.exports = {
    CartDeliveryFeeController,
    cartDeliveryFeeComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-delivery-fee.component.js